module.exports = __webpack_public_path__ + "static/media/placeholder-img.6bcb2843.jpg";